/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Compare_Event_Groups_Start_LabelInputs */

const en_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start:`)
};

const fr_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Début :`)
};

const de_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start:`)
};

const it_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizio:`)
};

const ru_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начинать:`)
};

const es_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comenzar:`)
};

const zh_cn2_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开始：`)
};

const ja_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`始める：`)
};

const hi_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शुरू करना:`)
};

const pt_pt2_compare_event_groups_start_label = /** @type {(inputs: Compare_Event_Groups_Start_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar:`)
};

/**
* | output |
* | --- |
* | "Start:" |
*
* @param {Compare_Event_Groups_Start_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const compare_event_groups_start_label = /** @type {((inputs?: Compare_Event_Groups_Start_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Compare_Event_Groups_Start_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_compare_event_groups_start_label(inputs)
	if (locale === "de") return de_compare_event_groups_start_label(inputs)
	if (locale === "it") return it_compare_event_groups_start_label(inputs)
	if (locale === "ru") return ru_compare_event_groups_start_label(inputs)
	if (locale === "es") return es_compare_event_groups_start_label(inputs)
	if (locale === "zh-CN") return zh_cn2_compare_event_groups_start_label(inputs)
	if (locale === "ja") return ja_compare_event_groups_start_label(inputs)
	if (locale === "hi") return hi_compare_event_groups_start_label(inputs)
	if (locale === "pt-PT") return pt_pt2_compare_event_groups_start_label(inputs)
	return en_compare_event_groups_start_label(inputs)
});